import React from 'react';

import { useSelector } from 'react-redux';

import PurchasePromoCode from '../../promo-codes/PurchasePromoCode';
import NumberOfDrawsSelect from '../Pick/options/NumberOfDrawsSelect';
import Purchase from '../elements/Purchase';
import ResellerModule from '../elements/ResellerModule';
import SelectableLotteryDrawDatesModule from '../elements/SelectableLotteryDrawDatesModule';

import { RootState } from '../redux/store';

import LotteryPicker from './picker/LotteryPicker';

export default function DefaultView() {
    const { lottery, resellerOptionsEnabled, selectableDrawDateTimes } = useSelector(
        (state: RootState) => state.playStore
    );

    const availablePurchaseOptions = [
        {
            key: 'selectableDrawDates',
            component: <SelectableLotteryDrawDatesModule />,
            isVisible: selectableDrawDateTimes.length,
        },
        {
            key: 'resellerModule',
            component: <ResellerModule />,
            isVisible: resellerOptionsEnabled,
        },
        {
            key: 'numberOfDraws',
            component: <NumberOfDrawsSelect />,
            isVisible: lottery.isMultiDrawEnabled,
        },
    ].filter((option) => option.isVisible);

    return (
        <>
            <LotteryPicker />

            <div
                id="purchase-options"
                className="w-100 purchase-options purchase-options-pick user-guide-play-ticket-type"
            >
                <div className="row">
                    {availablePurchaseOptions.map((option, index) => {
                        const isLastSingleItem = index === availablePurchaseOptions.length - 1 && index % 2 === 0;
                        return (
                            <div key={option.key} className={`col-${isLastSingleItem ? '12' : '6'}`}>
                                {option.component}
                            </div>
                        );
                    })}
                </div>
            </div>
            <PurchasePromoCode />
            <Purchase />
        </>
    );
}
